export default __webpack_public_path__ + "static/walgreens-cb5139bb7a8b495bfcf8a7165a681941.svg";